import React from 'react';
import { createPortal } from 'react-dom';
// scss
import './Loader.scss';

const modalRoot = document.querySelector('#modal-root');

const Loader = ({ local = false }) => {
  return local ? (
    <div className="loader__backdroop backdrop">
      <div className="loader__content lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  ) : (
    createPortal(
      <div className="loader__backdroop backdrop">
        <div className="loader__content lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>,
      modalRoot
    )
  );
};

export default Loader;
